// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Scalars = require("../../scalars/Scalars.bs.js");
var UTCDate = require("../../reason/common/types/UTCDate.bs.js");
var DateFns = require("date-fns");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var TailwindMerge = require("tailwind-merge");
var AgentProfilePhoto = require("../common/Agent/AgentProfilePhoto.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var ChapterMembersListItem_agent_graphql = require("../../__generated__/ChapterMembersListItem_agent_graphql.bs.js");

var convertFragment = ChapterMembersListItem_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ChapterMembersListItem_agent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ChapterMembersListItem_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ChapterMembersListItem_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ChapterMembersListItem_agent_graphql.node, convertFragment, fRef);
}

var AgentFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function joinedText(date) {
  return "Joined " + (DateFns.formatDistance(date, new Date()) + " ago");
}

function ChapterMembersListItem(props) {
  var agent = use(props.agent);
  var getRegisteredAt = function (className) {
    var date = agent.registeredAt;
    if (date !== undefined) {
      return JsxRuntime.jsx("div", {
                  children: joinedText(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(Caml_option.valFromOption(date)))),
                  className: TailwindMerge.twMerge([
                        "text-gray-500",
                        className
                      ])
                });
    } else {
      return null;
    }
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(AgentProfilePhoto.make, {
                            profilePhoto: agent.fragmentRefs
                          }),
                      className: "flex flex-col justify-center items-center"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("div", {
                                            children: agent.displayName,
                                            className: "font-medium text-lg text-gray-900"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: Core__Option.getOr(agent.brokerage, ""),
                                            className: ""
                                          }),
                                      getRegisteredAt("md:hidden my-4"),
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                                  href: "/agents/" + agent.id,
                                                  size: "small",
                                                  icon: "UserProfile",
                                                  children: Caml_option.some("View " + (Core__Option.getOr(agent.firstName, agent.displayName) + "'s profile"))
                                                }),
                                            className: "mt-4"
                                          })
                                    ]
                                  }),
                              getRegisteredAt("hidden md:block")
                            ],
                            className: "flex flex-col md:flex-row justify-between"
                          }),
                      className: "grow"
                    })
              ],
              className: "flex flex-col md:flex-row border border-gray-300 p-4 gap-4 text-center md:text-left"
            });
}

var make = ChapterMembersListItem;

exports.AgentFragment = AgentFragment;
exports.joinedText = joinedText;
exports.make = make;
/* Scalars Not a pure module */
